import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-scroll";
import styled from "styled-components";
import NftRecordIcon from "./NftRecordIcon";
import Button from "../../../../common/components/Buttons/Button";
import { Heading6Bold } from "../../../../common/Typography/Heading6";
import { Heading3Bold } from "../../../../common/Typography/Heading3";

const Root = styled.div``;

const Container = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-height: 541px;
    max-width: 308px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const TitleWrapper = styled.div`
  padding-bottom: 57px;
`;

const Title = styled(Heading3Bold)`
  width: 100%;
  line-height: 47px;
  padding-right: 150px;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding-right: 0px;
  }
`;

const DescriptionWrapper = styled.div`
  padding-bottom: 68.15px;
`;

const Description = styled(Heading6Bold)`
  line-height: 26px;
  max-width: 308px;
`;

const NftRecordWrapper = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    justify-content: flex-start;
  }
`;

const SignupButtonWrapper = styled.div`
  align-self: self-start;
  padding-top: 60px;

  @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
    display: none;
  }
`;

const SignupInfoWeb = () => {
  const { t } = useTranslation();

  return (
    <Root>
      <Container>
        <TitleWrapper>
          <Title>{t("signup-info-title")}</Title>
        </TitleWrapper>
        <DescriptionWrapper>
          <Description>{t("signup-info-description")}</Description>
        </DescriptionWrapper>
        <NftRecordWrapper>
          <NftRecordIcon />
        </NftRecordWrapper>
        <SignupButtonWrapper>
          <Button
            as={Link}
            smooth
            to="signup-box"
            text={t("signup-box-label")}
            iconName="arrowDown"
          />
        </SignupButtonWrapper>
      </Container>
    </Root>
  );
};

export default SignupInfoWeb;
